
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col">
        <h4 class="modal-title">Create Contract Account</h4>
      </div>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <success></success>
      <div *ngIf="loading">
        <md-spinner-block></md-spinner-block>
      </div>
      <form #createCustomerForm="ngForm" *ngIf="!loading">
        <div class="row">
          <div class="form-group col-6">
            <label [ngClass]="soldToOptions &amp;&amp; soldToOptions.length &gt; 1? 'required':''">Sold-To BP ID</label>
            <input class="form-control muted-input font-italic text-muted" type="text" disabled [value]="businessPartner" *ngIf="soldToOptions &amp;&amp; soldToOptions.length &lt;= 1">
            <select class="form-control" id="soldToBPIDSelect" *ngIf="soldToOptions &amp;&amp; soldToOptions.length &gt; 1" (change)="onSoldToBPIDChange()" [(ngModel)]="soldToBPID" name="soldToBPIDSelect">
              <option></option>
              <option *ngFor="let cv of soldToOptions" [ngValue]="cv.businessPartnerId">{{ cv.menuName }}  </option>
            </select>
          </div>
          <div class="form-group col-6">
            <label class="required" for="contractAccountName">Contract Account Name</label>
            <input class="form-control" id="contractAccountName" name="contractAccountName" type="text" [(ngModel)]="contractAccountName">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label>Contract Account Category</label>
            <select class="form-control" [(ngModel)]="contractAccountCategory" name="contractAccountCategory" (change)="setDefaultAccDeterminationId()" [hidden]="true">
              <option></option>
              <option *ngFor="let cac of contractAccountCategoryOptions" [ngValue]="cac.id">{{ cac.value }}</option>
            </select>
            <input class="form-control muted-input font-italic text-muted" type="text" disabled [value]="contractAccountCategoryOptions[0].value">
          </div>
          <div class="form-group col-6">
            <label>Account Determination ID</label>
            <select class="form-control" [(ngModel)]="accountDeterminationId" name="accountDeterminationId" [hidden]="true">
              <option></option>
              <option *ngFor="let ad of accountDeterminationIdOptions" [ngValue]="ad.id">{{ ad.value }}</option>
            </select>
            <input class="form-control muted-input font-italic text-muted" type="text" disabled [value]="accountDeterminationIdOptions[1].value">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="required">Bill To Party</label>
            <select class="form-control" [hidden]="addressDetails.buildToParty &amp;&amp; addressDetails.buildToParty.length &lt;= 1" [(ngModel)]="billToParty" name="billToParty">
              <option></option>
              <option *ngFor="let cv of addressDetails.buildToParty" [ngValue]="cv.businessPartnerId">{{ cv.menuName }}</option>
            </select>
            <input class="form-control muted-input font-italic text-muted" type="text" disabled [value]="addressDetails.buildToParty[0].menuName" [hidden]="addressDetails.buildToParty &amp;&amp; addressDetails.buildToParty.length &gt; 1">
          </div>
          <div class="form-group col-6">
            <label class="required">Alternate Payer: </label>
            <select class="form-control" [hidden]="addressDetails.alternatePayer &amp;&amp; addressDetails.alternatePayer.length &lt;= 1" [(ngModel)]="alternatePayer" name="alternatePayer" (ngModelChange)="updatePaymentTerms($event)" [disabled]="isAlternatePayerDisabled">
              <option></option>
              <option *ngFor="let cv of addressDetails.alternatePayer" [ngValue]="cv.businessPartnerId">{{ cv.menuName }}</option>
            </select>
            <input class="form-control muted-input font-italic text-muted" type="text" disabled [value]="addressDetails.alternatePayer[0].menuName" [hidden]="addressDetails.alternatePayer &amp;&amp; addressDetails.alternatePayer.length &gt; 1">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="required">Payment Terms</label>
            <select class="form-control" [(ngModel)]="paymentTerms" name="paymentTerms">
              <option></option>
              <option *ngFor="let pt of paymentTermOptions" [ngValue]="pt.id">{{ pt.value }}</option>
            </select>
          </div>
          <div class="form-group col-6">
            <label class="required">Correspondence Variant</label>
            <select class="form-control" [(ngModel)]="correspondenceVariant" name="correspondenceVariant">
              <option></option>
              <option *ngFor="let cv of correspondenceVariantOptions" [ngValue]="cv.id">{{ cv.value }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label class="required" for="companyCodeGroup">Company Code Group</label>
            <input class="form-control" id="companyCodeGroup" name="companyCodeGroup" type="text" [(ngModel)]="companyCodeGroup">
          </div>
          <div class="form-group col-6">
            <label class="required" for="standardCompanyCode">Standard Company Code</label>
            <input class="form-control" id="standardCompanyCode" name="standardCompanyCode" type="text" [(ngModel)]="standardCompanyCode">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label>Currency</label>
            <select class="form-control" [(ngModel)]="currency" name="currency">
              <option></option>
              <option *ngFor="let curr of currencyOptions" [ngValue]="curr.id">{{ curr.value }}</option>
            </select>
          </div>
          <div class="form-group col-6">
            <label class="required">Invoice Scheduling</label>
            <select class="form-control" [(ngModel)]="invoiceScheduling" name="invoiceScheduling">
              <option></option>
              <option *ngFor="let inSc of invoiceSchedulingValues" [ngValue]="inSc.id">{{ inSc.value }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label for="correspondenceRecipient">Correspondence Recipient</label>
            <input class="form-control" id="correspondenceRecipient" name="correspondenceRecipient" type="text" [(ngModel)]="correspondenceRecipient">
          </div>
          <div class="form-group col-6">
            <label>Invoice Language</label>
            <select class="form-control" [(ngModel)]="invoiceLanguage" name="invoiceLanguage">
              <option></option>
              <option *ngFor="let invoiceLanguage of invoiceLanguageValues" [ngValue]="invoiceLanguage.id">{{ invoiceLanguage.value }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label>Invoice Distribution Method</label>
            <select class="form-control" [(ngModel)]="invoiceDistribuitionMethod" name="invoiceDistribuitionMethod">
              <option></option>
              <option *ngFor="let idm of invoiceDistribuitionMethodValues" [ngValue]="idm.id">{{ idm.id }} - {{ idm.value }}</option>
            </select>
          </div>
          <div class="form-group col-6">
            <label>Incoming Payment Method</label>
            <select class="form-control" [(ngModel)]="incomingPaymentMethod" name="incomingPaymentMethod">
              <option></option>
              <option *ngFor="let pm of incomingPaymentMethodValues" [ngValue]="pm.id">{{ pm.value }}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6" *ngIf="POR507_TMC || POR507_2_1_TMC">
            <label for="exchangeRateType">Exchange Rate Type</label>
            <div class="dropdown">
              <div class="exchangeRate" *ngIf="exchangeRateStatus">
                <div class="input-group">
                  <div class="input-group-prepend" (click)="toggleDropdown()"><span class="input-group-text pointer">Custom</span></div>
                  <input class="form-control" type="text" placeholder="Exchange Rate for custom" [(ngModel)]="exchangeRate" [ngModelOptions]="{standalone: true}" #exchangeRateInput><span class="icon oi oi-chevron-bottom arrowdown pointer" (click)="toggleDropdown()"></span>
                </div><span class="text-red">  Please Enter Exchange Rate for custom type</span>
              </div>
              <button class="btn btn-secondary dropdown-toggle DropdownText" *ngIf="exchangeRateStatus==false" type="button" id="dropdownMenuButton" data-toggle="dropdown"  aria-expanded="false" (click)="toggleDropdown()">{{ exchangeRateType || 'Select Exchange Rate Type' }}</button>
              <div class="dropdown-menu dropdown-exchangeRate" aria-labelledby="dropdownMenuButton" [ngClass]="{'show': isDropdownOpen}"><a class="dropdown-item" *ngFor="let list of exchangeRateTypeList" (click)="selectExchangeValue(list)" [ngClass]="{'selectedValue': list === exchangeRateType}">{{ list }}</a></div>
            </div>
          </div>
          <div class="form-group col-6">
            <label for="outgoingPaymentMethod">Outgoing Payment Method</label>
            <input class="form-control" id="outgoingPaymentMethod" name="outgoingPaymentMethod" type="text" [(ngModel)]="outgoingPaymentMethod">
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" title="Cancel" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary" type="button" title="Save changes" (click)="createContractAccount()">Create Contract Account</button>
    </div>
  </div>
</div>